<template>
    <span
        v-html="svgIcon"
        :class="[$style['mds-icon'], sizeClass]"
        aria-hidden="true"
        :data-mds-version="version"
        :data-mds-icon-name="name"
    ></span>
</template>

<script>
    import icons from '../dist/mds-icons.json';

    import MdsIconProps from './icon_props.js';

    export default {
        name: 'MdsIcon',
        props: MdsIconProps,
        customIcons: {},
        computed: {
            sizeClass() {
                return this.size === 'small' ? this.$style['mds-icon--small'] : '';
            },
            svgIcon() {
                return icons[this.name] || this.$options.customIcons[this.name];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './icon.scss';
</style>
